import React, { useState, useRef } from "react";
import { BLUE, NAVY, LIGHT, TEXT, MUTED, GREEN, GREEN_LIGHT, GREEN_BORD, GMAPS_URL, AMAPS_URL } from "./data";

export function PulsingDot() {
  return (
    <span style={{position:"relative",display:"inline-block",width:10,height:10,marginRight:8,flexShrink:0}}>
      <span style={{position:"absolute",inset:0,borderRadius:"50%",background:"#22C55E",animation:"kd-ping 1.8s cubic-bezier(0,0,0.2,1) infinite"}}/>
      <span style={{position:"absolute",inset:0,borderRadius:"50%",background:"#22C55E"}}/>
    </span>
  );
}

export function RadioDot({checked}) {
  return (
    <div style={{width:18,height:18,borderRadius:"50%",border:`2px solid ${checked?BLUE:"#D1D5DB"}`,background:checked?BLUE:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.15s"}}>
      {checked&&<div style={{width:6,height:6,borderRadius:"50%",background:"#fff"}}/>}
    </div>
  );
}

export function StarRow() {
  return <div style={{display:"flex",gap:2}}>{[...Array(5)].map((_,i)=><span key={i} style={{color:"#F59E0B",fontSize:15}}>★</span>)}</div>;
}

export function FAQItem({q,a}) {
  const [open,setOpen]=useState(false);
  return (
    <div style={{borderBottom:"1px solid #E5E7EB"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{width:"100%",textAlign:"left",padding:"18px 0",display:"flex",justifyContent:"space-between",alignItems:"center",background:"none",border:"none",cursor:"pointer",fontFamily:"'Outfit',sans-serif",fontSize:15,fontWeight:600,color:TEXT,gap:16}}>
        <span>{q}</span>
        <span style={{width:26,height:26,borderRadius:"50%",background:open?BLUE:LIGHT,color:open?"#fff":BLUE,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0,transition:"all 0.2s",fontWeight:700}}>{open?"−":"+"}</span>
      </button>
      <div style={{maxHeight:open?400:0,overflow:"hidden",transition:"max-height 0.32s ease"}}>
        <p style={{paddingBottom:18,color:MUTED,lineHeight:1.8,fontSize:14}}>{a}</p>
      </div>
    </div>
  );
}

export function BeforeAfterSlider({before,after}) {
  const [pos,setPos]=useState(50);
  const ref=useRef(null),drag=useRef(false);
  const move=cx=>{if(!ref.current)return;const r=ref.current.getBoundingClientRect();setPos(Math.max(0,Math.min((cx-r.left)/r.width*100,100)));};
  return (
    <div ref={ref} style={{position:"relative",userSelect:"none",cursor:"ew-resize",borderRadius:12,overflow:"hidden",aspectRatio:"16/9",background:"#E5E7EB"}}
      onMouseDown={e=>{drag.current=true;move(e.clientX);}} onMouseMove={e=>{if(drag.current)move(e.clientX);}}
      onMouseUp={()=>{drag.current=false;}} onMouseLeave={()=>{drag.current=false;}}
      onTouchStart={e=>{drag.current=true;move(e.touches[0].clientX);}}
      onTouchMove={e=>{e.preventDefault();if(drag.current)move(e.touches[0].clientX);}} onTouchEnd={()=>{drag.current=false;}}>
      <img src={before} alt="Before detail" style={{position:"absolute",inset:0,width:"100%",height:"100%",objectFit:"cover",pointerEvents:"none"}}/>
      <div style={{position:"absolute",inset:0,clipPath:`inset(0 ${100-pos}% 0 0)`,pointerEvents:"none"}}>
        <img src={after} alt="After detail" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
      </div>
      <div style={{position:"absolute",top:0,bottom:0,left:`${pos}%`,width:3,background:"#fff",transform:"translateX(-50%)",pointerEvents:"none"}}>
        <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:40,height:40,borderRadius:"50%",background:"#fff",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 2px 12px rgba(0,0,0,0.2)",color:NAVY,fontSize:16,fontWeight:800}}>⟺</div>
      </div>
      <div style={{position:"absolute",top:12,left:12,background:"rgba(0,0,0,0.55)",color:"#fff",padding:"3px 10px",borderRadius:5,fontSize:11,fontWeight:700,pointerEvents:"none"}}>BEFORE</div>
      <div style={{position:"absolute",top:12,right:12,background:BLUE,color:"#fff",padding:"3px 10px",borderRadius:5,fontSize:11,fontWeight:700,pointerEvents:"none"}}>AFTER</div>
    </div>
  );
}

export function ZipResult({zipInfo}) {
  if(!zipInfo)return null;
  const{miles,city,state}=zipInfo;

  // Under ~25 miles: clearly free, well within 30 min
  if(miles<=25) return(
    <div style={{marginTop:8,padding:"12px 14px",borderRadius:8,background:GREEN_LIGHT,border:`1.5px solid ${GREEN_BORD}`,display:"flex",alignItems:"flex-start",gap:10}}>
      <div style={{width:26,height:26,borderRadius:"50%",background:GREEN,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:13,color:"#fff",fontWeight:800}}>✓</div>
      <div>
        <p style={{fontSize:13,fontWeight:700,color:GREEN,marginBottom:2}}>You are in range!</p>
        <p style={{fontSize:12,color:"#166534",lineHeight:1.55}}>{city}, {state} is about {miles} miles from Brookville. Mobile service is available with no travel charge.</p>
      </div>
    </div>
  );

  // 25 to 60 miles: getting close to or past 30 min, possible travel charge
  if(miles<=60) return(
    <div style={{marginTop:8,padding:"12px 14px",borderRadius:8,background:"#EFF6FF",border:"1.5px solid #BFDBFE",display:"flex",alignItems:"flex-start",gap:10}}>
      <div style={{width:26,height:26,borderRadius:"50%",background:BLUE,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:12,color:"#fff",fontWeight:800}}>i</div>
      <div>
        <p style={{fontSize:13,fontWeight:700,color:NAVY,marginBottom:2}}>A bit further out</p>
        <p style={{fontSize:12,color:MUTED,lineHeight:1.55}}>{city}, {state} is about {miles} miles from Brookville. If this puts you past 30 minutes away, a small travel charge may apply. Everything is confirmed before booking. Drop-off in Brookville is always available with no travel charge.</p>
      </div>
    </div>
  );

  // Over 60 miles: likely outside range
  return(
    <div style={{marginTop:8,padding:"12px 14px",borderRadius:8,background:"#F9FAFB",border:"1.5px solid #E5E7EB",display:"flex",alignItems:"flex-start",gap:10}}>
      <div style={{width:26,height:26,borderRadius:"50%",background:"#9CA3AF",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:13,color:"#fff",fontWeight:800}}>!</div>
      <div>
        <p style={{fontSize:13,fontWeight:700,color:TEXT,marginBottom:2}}>This may be outside our mobile range</p>
        <p style={{fontSize:12,color:MUTED,lineHeight:1.55}}>{city}, {state} is about {miles} miles from Brookville. Drop-off at the Brookville location is the best option. Simply drop off and pick back up when done.</p>
      </div>
    </div>
  );
}

export function BrookvilleMap() {
  return(
    <div style={{position:"relative",borderRadius:12,overflow:"hidden",border:"1.5px solid #E5E7EB"}}>
      <svg viewBox="0 0 560 320" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",display:"block"}}>
        <rect width="560" height="320" fill="#F0F4FF"/>
        <path d="M 0 195 Q 90 188 180 198 Q 270 208 420 200 L 560 198" stroke="#C7D2FE" strokeWidth="6" fill="none" strokeLinecap="round"/>
        <text x="290" y="192" fontSize="10" fill="#6366F1" fontFamily="Outfit,sans-serif" fontWeight="700" textAnchor="middle">I-70</text>
        <path d="M 258 0 L 262 188 L 264 320" stroke="#C7D2FE" strokeWidth="6" fill="none" strokeLinecap="round"/>
        <text x="270" y="120" fontSize="10" fill="#6366F1" fontFamily="Outfit,sans-serif" fontWeight="700">I-75</text>
        <path d="M 262 188 Q 340 160 430 118" stroke="#DDD6FE" strokeWidth="3" fill="none" strokeLinecap="round"/>
        <circle cx="262" cy="210" r="6" fill="#6366F1"/><text x="278" y="208" fontSize="12" fill={NAVY} fontFamily="Outfit,sans-serif" fontWeight="700">Dayton</text>
        <circle cx="262" cy="148" r="4" fill="#818CF8"/><text x="272" y="146" fontSize="10" fill={MUTED} fontFamily="Outfit,sans-serif" fontWeight="600">Vandalia</text>
        <circle cx="175" cy="168" r="4" fill="#818CF8"/><text x="120" y="165" fontSize="10" fill={MUTED} fontFamily="Outfit,sans-serif" fontWeight="600">Englewood</text>
        <circle cx="212" cy="205" r="4" fill="#818CF8"/><text x="148" y="210" fontSize="10" fill={MUTED} fontFamily="Outfit,sans-serif" fontWeight="600">Trotwood</text>
        <circle cx="430" cy="118" r="5" fill="#818CF8"/><text x="437" y="116" fontSize="11" fill={MUTED} fontFamily="Outfit,sans-serif" fontWeight="600">Springfield</text>
        <circle cx="245" cy="270" r="4" fill="#818CF8"/><text x="255" y="278" fontSize="10" fill={MUTED} fontFamily="Outfit,sans-serif" fontWeight="600">Miamisburg</text>
        <circle cx="88" cy="193" r="20" fill={BLUE} opacity="0.12"/>
        <circle cx="88" cy="193" r="10" fill={BLUE}/>
        <circle cx="88" cy="193" r="4" fill="#fff"/>
        <polygon points="88,193 82,208 94,208" fill={BLUE}/>
        <rect x="100" y="179" width="108" height="30" rx="6" fill="#fff" opacity="0.93"/>
        <text x="154" y="192" fontSize="12" fill={NAVY} fontFamily="Outfit,sans-serif" fontWeight="800" textAnchor="middle">Brookville</text>
        <text x="154" y="204" fontSize="9" fill={BLUE} fontFamily="Outfit,sans-serif" fontWeight="600" textAnchor="middle">Drop-off Location</text>
        <polygon points="530,18 526,30 534,30" fill="#C7D2FE"/>
        <line x1="530" y1="30" x2="530" y2="42" stroke="#C7D2FE" strokeWidth="1.5"/>
        <text x="530" y="15" fontSize="11" fill="#A5B4FC" fontFamily="Outfit,sans-serif" fontWeight="700" textAnchor="middle">N</text>
        <text x="510" y="310" fontSize="11" fill="#C7D2FE" fontFamily="Outfit,sans-serif" fontWeight="700" textAnchor="end">Ohio</text>
      </svg>
      <div style={{position:"absolute",bottom:10,left:10,display:"flex",gap:6}}>
        {[["📍 Google Maps",GMAPS_URL],["🗺️ Apple Maps",AMAPS_URL]].map(([lbl,href])=>(
          <a key={lbl} href={href} target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",gap:5,padding:"6px 11px",borderRadius:6,background:"#fff",border:"1.5px solid #E5E7EB",fontSize:11,fontWeight:600,color:TEXT,textDecoration:"none",fontFamily:"Outfit,sans-serif",boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>{lbl}</a>
        ))}
      </div>
    </div>
  );
}

export function Navbar({activePage}) {
  const [scrolled,setScrolled]=React.useState(false);
  React.useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>30);
    window.addEventListener("scroll",fn);return()=>window.removeEventListener("scroll",fn);
  },[]);
  const scrollTo=id=>{
    if(activePage!=="home"){window.location.href="/#"+id;return;}
    document.getElementById(id)?.scrollIntoView({behavior:"smooth"});
  };
  return(
    <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:100,padding:"12px 48px",display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(255,255,255,0.97)",backdropFilter:"blur(12px)",borderBottom:"1px solid #E5E7EB",boxShadow:scrolled?"0 2px 12px rgba(0,0,0,0.07)":"none",transition:"box-shadow 0.3s",fontFamily:"'Outfit',sans-serif"}}>
      <a href="/" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
        <img src="/logo.png" alt="Kodiak Detailing" style={{width:36,height:36,borderRadius:"50%",objectFit:"cover"}}/>
        <span style={{fontWeight:800,fontSize:16,color:NAVY}}>Kodiak <span style={{color:BLUE}}>Detailing</span></span>
      </a>
      <div className="nav-links" style={{display:"flex",gap:24,alignItems:"center"}}>
        <a href="/#services" onClick={e=>{if(activePage==="home"){e.preventDefault();scrollTo("services");}}} style={{color:TEXT,textDecoration:"none",fontSize:14,fontWeight:500}}>Services</a>
        <a href="/#pricing" onClick={e=>{if(activePage==="home"){e.preventDefault();scrollTo("pricing");}}} style={{color:TEXT,textDecoration:"none",fontSize:14,fontWeight:500}}>Pricing</a>
        <a href="/about" style={{color:TEXT,textDecoration:"none",fontSize:14,fontWeight:500}}>About</a>
        <a href="/#book" onClick={e=>{if(activePage==="home"){e.preventDefault();scrollTo("book");}}} style={{background:BLUE,color:"#fff",textDecoration:"none",padding:"8px 18px",borderRadius:6,fontSize:13,fontWeight:700}}>Book Now</a>
      </div>
    </nav>
  );
}

export const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  html{scroll-behavior:smooth;}
  body{font-family:'Outfit',sans-serif;}
  @keyframes kd-ping{75%,100%{transform:scale(2.2);opacity:0;}}
  @keyframes toast-in{from{opacity:0;transform:translateY(-10px);}to{opacity:1;transform:translateY(0);}}

  .btn-p{background:#1B4FD8;color:#fff;border:none;padding:14px 32px;font-family:'Outfit',sans-serif;font-weight:700;font-size:15px;border-radius:6px;cursor:pointer;transition:all 0.18s;}
  .btn-p:hover{background:#0F2A6B;transform:translateY(-1px);}
  .btn-p:disabled{opacity:0.55;cursor:not-allowed;transform:none;}
  .btn-o{background:transparent;color:#1B4FD8;border:2px solid #1B4FD8;padding:12px 28px;font-family:'Outfit',sans-serif;font-weight:700;font-size:14px;border-radius:6px;cursor:pointer;transition:all 0.18s;}
  .btn-o:hover{background:#1B4FD8;color:#fff;}
  .btn-sm{background:transparent;color:#1B4FD8;border:1.5px solid rgba(27,79,216,0.3);padding:6px 14px;font-family:'Outfit',sans-serif;font-weight:600;font-size:12px;border-radius:20px;cursor:pointer;transition:all 0.18s;}
  .btn-sm:hover{background:#EEF3FF;}

  nav a{color:#111827;text-decoration:none;font-size:14px;font-weight:500;transition:color 0.18s;}
  nav a:hover{color:#1B4FD8;}

  input,select,textarea{background:#F9FAFB;border:1.5px solid #E5E7EB;color:#111827;padding:12px 14px;font-family:'Outfit',sans-serif;font-size:14px;width:100%;outline:none;transition:border-color 0.18s;border-radius:6px;}
  input:focus,select:focus,textarea:focus{border-color:#1B4FD8;background:#fff;}
  input::placeholder,textarea::placeholder{color:#9CA3AF;}
  select option{background:#fff;}
  .err{color:#DC2626;font-size:12px;margin-top:4px;}

  .svc-tab{padding:10px 16px;font-family:'Outfit',sans-serif;font-size:14px;font-weight:600;border:2px solid #E5E7EB;background:#fff;color:#6B7280;border-radius:6px;cursor:pointer;transition:all 0.18s;text-align:left;}
  .svc-tab.on{border-color:#1B4FD8;background:#EEF3FF;color:#1B4FD8;}
  .svc-tab:hover:not(.on){border-color:#D1D5DB;color:#111827;}

  .rrow{display:flex;align-items:flex-start;gap:12px;padding:13px 16px;border:1.5px solid #E5E7EB;border-radius:8px;cursor:pointer;transition:all 0.15s;}
  .rrow:hover{border-color:rgba(27,79,216,0.3);}
  .rrow.on{border-color:#1B4FD8;background:#EEF3FF;}

  .vcard{border:2px solid #E5E7EB;border-radius:10px;overflow:hidden;cursor:pointer;transition:all 0.2s;background:#0F2A6B;}
  .vcard:hover{border-color:rgba(27,79,216,0.4);transform:translateY(-2px);}
  .vcard.on{border-color:#1B4FD8;box-shadow:0 0 0 3px rgba(27,79,216,0.13);}
  .vcard img{width:100%;height:90px;object-fit:cover;display:block;opacity:0.85;transition:opacity 0.2s;}
  .vcard:hover img,.vcard.on img{opacity:1;}
  .vcard-info{padding:8px 10px;background:#0F2A6B;transition:background 0.2s;}
  .vcard.on .vcard-info{background:#1B4FD8;}
  .vcard-label{font-size:11px;font-weight:700;color:#fff;line-height:1.3;}
  .vcard-ex{font-size:9px;color:rgba(255,255,255,0.55);margin-top:2px;line-height:1.3;}

  .day-chip{padding:8px 14px;border:1.5px solid #E5E7EB;border-radius:20px;cursor:pointer;font-family:'Outfit',sans-serif;font-size:13px;font-weight:600;color:#6B7280;background:#fff;transition:all 0.15s;}
  .day-chip.on{border-color:#1B4FD8;background:#EEF3FF;color:#1B4FD8;}
  .day-chip:hover:not(.on){border-color:#D1D5DB;color:#111827;}

  .fcard{background:#fff;border:1.5px solid #E5E7EB;border-radius:10px;padding:24px;}
  .fcard h3{font-size:16px;font-weight:700;color:#0F2A6B;margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #F3F4F6;}

  .appt-card{display:flex;flex-direction:column;gap:6px;padding:16px;border:1.5px solid #E5E7EB;border-radius:10px;cursor:pointer;transition:border-color 0.18s,background 0.18s;background:#fff;}
  .appt-card:hover{border-color:rgba(27,79,216,0.3);}
  .appt-card.on{border-color:#1B4FD8;background:#EEF3FF;}
  .appt-card.dis{opacity:0.4;cursor:not-allowed;}

  .sticky-bar{display:none;}
  @media(max-width:768px){
    .sticky-bar{display:flex !important;}
    .nav-links{display:none !important;}
    .two-col{grid-template-columns:1fr !important;}
    .three-col{grid-template-columns:1fr !important;}
    .four-col{grid-template-columns:1fr 1fr !important;}
    .hero-pad{padding:100px 20px 60px !important;}
    section{padding-left:20px !important;padding-right:20px !important;}
    nav{padding:12px 16px !important;}
    .appt-grid{grid-template-columns:1fr !important;}
    .pricing-grid{grid-template-columns:1fr 80px 90px !important;}
  }
`;
